export enum RoleTypes {
  Administrator = 0,
  Assistant = 1,
  Accounting = 3,
  PartnerAdmin = 100,
  PrintAdmin = 200,
}
